module.exports = __webpack_public_path__ + "img/Pista_3618_2.af148950.png";